import { Container } from '@plone/components';
import { socials } from '../Blocks/Socials/socials';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  followVMM: {
    id: 'FollowVMM',
    defaultMessage: 'Follow VMM on social media',
  },
  vmmBaseline: {
    id: 'Making our living environment climate-proof',
    defaultMessage: 'A climate-proof living environment?',
  },
  vmmBaseline2: {
    id: 'we work with partners to develop a sustainable policy',
    defaultMessage:
      'Together with partners we work towards sustainable solutions for air, water and climate.',
  },
  flanders: {
    id: 'Flanders',
    defaultMessage: 'Flanders',
  },
  environmentagency: {
    id: 'Environment Agency',
    defaultMessage: 'Environment Agency',
  },
});

type Props = {};

const sitemapEN = {
  content: [
    {
      title: 'About VMM',
      refLink: '/about-vmm',
      links: [
        ['Our mission', '/about-vmm/our-mission'],
        ['Our vision', '/about-vmm/our-vision'],
        ['Organisation', '/about-vmm/organisation'],
      ],
    },
    {
      title: 'Projects',
      refLink: '/projects',
      links: [
        ['Our philosophy', '/projects/our-philosophy'],
        ['Project portfolio', '/projects/project-portfolio'],
      ],
    },
    {
      title: 'News & Events',
      refLink: '/news-events',
      links: [
        ['News', '/news-events/news'],
        ['Events', '/news-events/events'],
      ],
    },
    {
      title: 'Contact',
      refLink: '/contact',
      links: [
        ['Get in touch', '/contact/get-in-touch'],
        ['Connect', '/contact/connect'],
      ],
    },
  ],
  misc: [],
};

const sitemapNL = {
  content: [
    {
      title: 'Feiten & cijfers',
      refLink: '/feiten-cijfers',
      links: [
        ['Water', '/feiten-cijfers/water'],
        ['Lucht', '/feiten-cijfers/lucht'],
        ['Klimaat', '/feiten-cijfers/klimaat'],
        ['Kaarten & cijfers', '/feiten-cijfers/catalogus-feiten-cijfers'],
      ],
    },
    {
      title: 'Beleid',
      refLink: '/beleid',
      links: [
        ['Luchtbeleid', '/beleid/luchtbeleid'],
        ['Waterbeleid', '/beleid/waterbeleid'],
        ['Klimaatadaptie', '/beleid/klimaatadaptatie'],
      ],
    },
    {
      title: 'Diensten & producten',
      refLink: '/diensten-producten',
      links: [
        ['Burgers', '/diensten-producten/burgers'],
        ['Lokale overheid', '/diensten-producten/lokale-overheid'],
        ['Bedrijven', '/diensten-producten/bedrijven'],
      ],
    },
    {
      title: 'Projecten',
      refLink: '/projecten',
      links: [
        ['Lokale projecten', '/projecten/lokaal'],
        ['Europese projecten', '/projecten/internationaal'],
      ],
    },
    {
      title: 'Tips',
      refLink: '/tips',
      links: [
        ['Water en droogte', '/tips/water'],
        ['Luchtkwaliteit en -vervuiling', '/tips/lucht'],
        ['Klimaat', '/tips/klimaat'],
      ],
    },
  ],
  misc: [
    ['Nieuws', '/nieuws'],
    ['Evenementen', '/evenementen'],
    ['Over VMM', '/over-vmm'],
    ['Jobs', '/jobs'],
    ['Publicaties', '/publicaties'],
    ['Pers', '/pers'],
    ['Contact', '/contact'],
  ],
};
export const ContentFooter = (props: Props) => {
  const intl = useIntl();
  const sitemap = intl.locale === 'en' ? sitemapEN : sitemapNL;
  return (
    <div className="footer">
      <Container layout className="footer__container">
        <div className="footer__branding">
          <div className="footer__branding-logo">
            <h2>
              {intl.formatMessage(messages.flanders)}
              <br />
              <b>{intl.formatMessage(messages.environmentagency)}</b>
            </h2>

            <p>
              {intl.formatMessage(messages.vmmBaseline)}
              <br />
              {intl.formatMessage(messages.vmmBaseline2)}
            </p>
          </div>
          <div className="footer__socials">
            <h3>{intl.formatMessage(messages.followVMM)}</h3>
            <div>
              {socials.map(([src, href, size, titl]) => (
                <a href={href} key={src}>
                  <img
                    src={src}
                    style={{
                      width: size,
                      height: size,
                    }}
                    alt={titl}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="footer__sitemap">
          <div className="footer__content-links">
            {sitemap.content.map(({ title, refLink, links }) => (
              <div className="column" key={title}>
                <a className="section" href={refLink} alt={title} key={title}>
                  <h4>{title}</h4>
                </a>
                {links.map(([label, href]) => (
                  <a className="subsection" href={href} alt={label} key={label}>
                    {label}
                  </a>
                ))}
              </div>
            ))}
          </div>
          {sitemap.misc.length > 0 && <div className="footer__hr" />}
          {sitemap.misc.length > 0 && (
            <div className="footer__links">
              {sitemap.misc.map(([label, href]) => (
                <a href={href} key={label}>
                  {label}
                </a>
              ))}
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ContentFooter.propTypes = {
  /**
   * i18n object
   */
};
